"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SET_PROJECT_USER_PARAMS = exports.ADD_PROJECT = exports.SET_CURRENT_PROJECT = exports.SET_PROJECTS = exports.SET_USER = void 0;
exports.SET_USER = "@@COMBINED_STATE/COMBINED_AUTH/SET_USER";
exports.SET_PROJECTS = "@@COMBINED_STATE/COMBINED_STATE_PROJECTS/SET_PROJECTS";
exports.SET_CURRENT_PROJECT = "@@COMBINED_STATE/COMBINED_STATE_PROJECTS/SET_CURRENT_PROJECT";
exports.ADD_PROJECT = "@@COMBINED_STATE/COMBINED_STATE_PROJECTS/ADD_PROJECT";
exports.SET_PROJECT_USER_PARAMS = "@@COMBINED_STATE/COMBINED_STATE_PROJECTS/SET_PROJECT_USER_PARAMS";
